import { ActionName } from '../../../../constants/Bi';
import { MediaManagerSDKAnyItem } from '../../../media-manager-sdk';

export enum ActionTarget {
  File = 'file',
  Folder = 'folder',
  Batch = 'batch',
  FileInPreviewMode = 'file_in_preview_mode',
  FolderInPreviewMode = 'folder_in_preview_mode',
  Empty = 'empty',
  Breadcrumbs = 'breadcrumbs',
  Panel = 'panel',
  Board = 'board',
}

export enum ActionClickOrigin {
  File = 'file',
  BoardsList = 'boards_list',
  ThreeDots = 'three_dots',
  RightClick = 'right_click',
  MoreActionsTopRight = 'more_actions_top_right',
  InfoPanel = 'more_info',
  InfoPanelActionDots = 'more_info_action_dots',
  InfoPanelPreview = 'more_info_preview',
  InfoPanelFavButton = 'info_panel_fav_button',
  TopBar = 'top_bar',
  Keyboard = 'keyboard',
  Notification = 'notification',
  FileTitle = 'file_title',
  SideBarDragDrop = 'sidebar_drag_drop',
  BreadcrumbsDragDrop = 'breadcrumbs_drag_drop',
  FolderDragAndDrop = 'folder_drag_and_drop',
}

export interface IWithTrackActionsInner {
  trackActionsOpenClick: (
    selectedItems: MediaManagerSDKAnyItem[],
    clickOrigin: ActionClickOrigin,
    target?: ActionTarget,
  ) => void;
  trackActionsMenuClick: (
    selectedItems: MediaManagerSDKAnyItem[],
    clickOrigin: ActionClickOrigin,
    actionName: ActionName,
    target?: ActionTarget,
  ) => void;
  trackActionsDone: (selectedItems: MediaManagerSDKAnyItem[], actionName: ActionName) => void;
  setLastActionParams: (
    selectedItems: MediaManagerSDKAnyItem[],
    params: { clickOrigin: ActionClickOrigin; target?: ActionTarget },
  ) => void;
  preserveOriginAndTargetAfterDone: () => void;
  clearOriginAndTarget: () => void;
}

export interface IWithTrackActionsOuter {}
